import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'app-message-board',
  templateUrl: './message-board.component.html',
  styleUrls: ['./message-board.component.css'],
  standalone: false
})

export class MessageBoardComponent implements OnInit {

  messageBord = [];
  message?: object;

  constructor(private sanitizer: DomSanitizer) { }

  ngOnInit() {
    const date = new Date();

    const year = date.getFullYear().toString();
    let month = (date.getMonth() + 1).toString();
    let day = date.getDate().toString();

    if (month.length < 2) {
      month = '0' + month;
    }

    if (day.length < 2) {
      day = '0' + day;
    }

    const currentDate = year + '-' + month + '-' + day;

    for (const key of this.messageBord) {
      if (currentDate >= key.date) {
        this.message = this.sanitizer.bypassSecurityTrustHtml(key.message);
      }
    }
  }

}
